import { Modal } from "react-bootstrap";

const ModifierAddDialogHeader = () => {
  return (
    <Modal.Header>
      <Modal.Title id="example-modal-sizes-title-lg">
        Add Product Modifier
      </Modal.Title>
    </Modal.Header>
  );
};

export default ModifierAddDialogHeader;